export default "__VITE_ASSET__Cg16ytT3__"